import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type PreRegisterService from 'tio-employee/services/pre-register';
import type RouterService from '@ember/routing/router-service';
import type SessionService from 'tio-employee/services/session';
import type { CompanySettingExtension as CompanySetting } from 'tio-data/data/resources/company-setting.ext';
import { shouldUseSsoRedirect } from 'tio-employee/utils/sso-auth-url';

const hasLandingPage = (settings: CompanySetting) =>
  settings?.landingPage && settings.landingPage?.isEnabled;

export default class LoginRoute extends Route {
  @service declare preRegister: PreRegisterService;
  @service declare router: RouterService;
  @service declare session: SessionService;

  queryParams = {
    email: { refreshModel: false },
    emailLogin: { refreshModel: false },
  };

  beforeModel() {
    const { preRegister, session, router } = this;
    const query = location.search;
    const params = new URLSearchParams(query);
    const forceEmailLogin = params.get('emailLogin');

    if (hasLandingPage(preRegister.settings) && !session.getTransientValue('landingPageViewed')) {
      router.transitionTo('welcome');
    } else if (shouldUseSsoRedirect(preRegister.settings, forceEmailLogin)) {
      window.location.href = preRegister.settings.ssoAuthUrl;
    }
  }
}
